import React, { useState } from 'react';
import styled from 'styled-components';
import { Half, SectionLine } from '@ontruck/fe-ui';
import { FormButton } from '../../ui/buttons/FormButton';
import RegularText from '../../ui/texts/RegularText';
import { PremiumInput } from '../../ui/inputs/customInput';
import ticketService from 'modules/emergencies/ticketService';

const NewCommentFormContainer = styled.div`
  padding: 16px;
  background-color: var(--accent-color-gray);
  border-top: 2px solid var(--white);
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
`;

const CustomRegularText = styled(RegularText)`
  font-size: 14px;
  color: var(--grey700);
`;

export const NewCommentForm = ({ ticketId, onCancel, onNewComment }) => {
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [isNotifyOwner, setIsNotifyOwner] = useState(false);
  const hasError = message.trim().length === 0;
  const onSave = async () => {
    setIsLoading(true);
    setShowErrors(true);
    if (hasError) {
      setIsLoading(false);
      return;
    }
    try {
      const body = {
        message,
        notify_owner: isNotifyOwner,
      };
      await ticketService.createComment({ ticketId, body });
      onNewComment(message);
      onCancel();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <NewCommentFormContainer>
      <CustomRegularText>New comment</CustomRegularText>
      <SectionLine>
        <PremiumInput
          type="text"
          label="Type the comment here"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          hasError={showErrors && hasError}
        />
      </SectionLine>
      <SectionLine>
        <label>Notify owner</label>
        <input
          onChange={() => {
            setIsNotifyOwner(!isNotifyOwner);
          }}
          type="checkbox"
          checked={isNotifyOwner}
          name={`notify-owner`}
        />
      </SectionLine>
      <ButtonsContainer>
        <Half>
          <FormButton variant="ghost" isDisabled={isLoading} onClick={onCancel}>
            Cancel
          </FormButton>
        </Half>
        <Half>
          <FormButton isDisabled={isLoading} onClick={onSave}>
            Save
          </FormButton>
        </Half>
      </ButtonsContainer>
    </NewCommentFormContainer>
  );
};
